/**
 * What kind of job, and what to call it.
 *
 * Most jobs are weddings, named after the couple. Events and associate work
 * (shooting for another photographer) have no couple, so they carry a title:
 * "CORE Fruit year-end function", "Second photographer for Liné".
 */

import { formatCouple } from './format'

export type JobKind = 'wedding' | 'couple_shoot' | 'event' | 'associate' | 'lifestyle' | 'brand' | 'other'

export const JOB_KIND_LABEL: Record<JobKind, string> = {
  wedding: 'Wedding',
  couple_shoot: 'Couple shoot',
  event: 'Event',
  associate: 'Associate',
  lifestyle: 'Lifestyle',
  brand: 'Brand',
  other: 'Other',
}

export type TeamRole =
  | 'lead_photographer'
  | 'lead_videographer'
  | 'second_photographer'
  | 'second_videographer'
  | 'content_creator'
  | 'assistant'

export const TEAM_ROLE_LABEL: Record<TeamRole, string> = {
  lead_photographer: 'Lead photographer',
  lead_videographer: 'Lead videographer',
  second_photographer: 'Second photographer',
  second_videographer: 'Second videographer',
  content_creator: 'Content creator',
  assistant: 'Assistant',
}

interface Person {
  first_name: string
  last_name?: string | null
}

/** The name a job goes by on the board and in headings. */
export function jobName(job: {
  kind?: JobKind | null
  title?: string | null
  primary_contact?: Person | null
  partner_contact?: Person | null
}): string {
  const title = job.title?.trim()
  if (title && job.kind !== 'wedding' && job.kind !== 'couple_shoot') return title
  const couple = formatCouple(job.primary_contact, job.partner_contact)
  if (couple === 'Unnamed' && title) return title
  return couple
}

/** The contract promises the team is confirmed 4–6 weeks before; flag from 6. */
export const TEAM_CONFIRM_DAYS = 42
